import { render, staticRenderFns } from "./member_parent_list.vue?vue&type=template&id=2847c76e"
import script from "./member_parent_list.vue?vue&type=script&lang=js"
export * from "./member_parent_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports